export const pipe =
  <T>(...fns: ((data: T) => T)[]): ((x: T) => T) =>
  (x: T) =>
    fns.reduce((v, f) => f(v), x);
